module.exports = __webpack_public_path__ + "img/BAIDU.756fa263.png";